import { FaWhatsapp } from "react-icons/fa";

function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/919443043074"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Universal Goodlife Ashram on WhatsApp"
      className="fixed bottom-6 right-6 bg-[#25D366] text-white p-4 rounded-full z-50 transition-all duration-300 ease-out shadow-[0_8px_30px_rgb(0,0,0,0.15)] hover:bg-[#20ba56] hover:scale-110 hover:-translate-y-1 active:scale-95 group"
    >
      <FaWhatsapp className="w-8 h-8 filter drop-shadow-sm transition-transform duration-300 group-hover:rotate-6" />
    </a>
  );
}

export default WhatsAppButton;